
<div class="row">
    <div class="col-12 col-md-4">
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{'active': type === 'game'}" [routerLink]="['/lo', company_uuid, 'setting-adjustment', 'game']">Game Adjustment</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{'active': type === 'bank'}" [routerLink]="['/lo', company_uuid, 'setting-adjustment', 'bank']">Bank Adjustment</a>
            </li>
        </ul>

        <div class="card rounded-0" *ngIf="type == 'game'" >
            <div class="card-body">
                <form #f="ngForm" (ngSubmit)="f.valid && ((data.debit || data.credit) && !(data.debit && data.credit)) && submit()" novalidate>
                    <h3 class="fs-4 fw-bold">Game Adjustment</h3>
                    <div class="mb-3">
                        <label for="game" class="form-label">Game *</label>
                        <select class="form-control" name="game" #game="ngModel" [(ngModel)]="data.game" required>
                            <option [value]="g.id" *ngFor="let g of games;">{{g.title}} ({{g.balance}})</option>
                        </select>
                        <div *ngIf="f.submitted && game.invalid" class="invalid-feedback">
                            <div *ngIf="game.errors.required">Game is required</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="debit" class="form-label">Debit (&#43; In)</label>
                        <input type="number" class="form-control" id="debit" name="credit" #credit="ngModel" [(ngModel)]="data.debit">
                        <div *ngIf="f.submitted && ((!data.debit && !data.credit) || (data.debit && data.credit))" class="invalid-feedback">
                            <div>You have to either debit or credit game. Can't be both value</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="credit" class="form-label">Credit (&#8722; Out)</label>
                        <input type="number" class="form-control" id="credit" name="credit" #credit="ngModel" [(ngModel)]="data.credit">
                        <div *ngIf="f.submitted && ((!data.debit && !data.credit) || (data.debit && data.credit))" class="invalid-feedback">
                            <div>You have to either debit or credit game. Can't be both value</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="remark" class="form-label">Remark</label>
                        <textarea class="form-control" name="remark" #remark="ngModel" [(ngModel)]="data.remark"></textarea>
                    </div>
                    <button type="submit" class="btn btn-primary">Adjustment</button>
                </form>
            </div>
        </div>

        <div class="card rounded-0" *ngIf="type == 'bank'" >
            <div class="card-body">
                <form #f="ngForm" (ngSubmit)="f.valid && ((data.debit || data.credit) && !(data.debit && data.credit)) && submit()" novalidate>
                    <h3 class="fs-4 fw-bold">Bank Adjustment</h3>
                    <div class="mb-3">
                        <label for="bank" class="form-label">Bank *</label>
                        <select class="form-control" name="bank" #bank="ngModel" [(ngModel)]="data.bank" required>
                            <option [value]="b.id" *ngFor="let b of banks;">{{b.title}} (RM {{b.balance}})</option>
                        </select>
                        <div *ngIf="f.submitted && bank.invalid" class="invalid-feedback">
                            <div *ngIf="bank.errors.required">Bank is required</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="debit" class="form-label">Debit (&#43; In)</label>
                        <input type="number" class="form-control" id="debit" name="credit" #credit="ngModel" [(ngModel)]="data.debit">
                        <div *ngIf="f.submitted && ((!data.debit && !data.credit) || (data.debit && data.credit))" class="invalid-feedback">
                            <div>You have to either enter debit or credit bank account. Can't be both value.</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="credit" class="form-label">Credit (&#8722; Out)</label>
                        <input type="number" class="form-control" id="credit" name="credit" #credit="ngModel" [(ngModel)]="data.credit">
                        <div *ngIf="f.submitted && ((!data.debit && !data.credit) || (data.debit && data.credit))" class="invalid-feedback">
                            <div>You have to either enter debit or credit bank account. Can't be both value.</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="remark" class="form-label">Remark</label>
                        <textarea class="form-control" name="remark" #remark="ngModel" [(ngModel)]="data.remark"></textarea>
                    </div>
                    <button type="submit" class="btn btn-primary">Adjustment</button>
                </form>
            </div>
        </div>

    </div>
    <div class="col-12 col-md-8">
        <app-tablev2 #table></app-tablev2>

    </div>
</div>

